import 'jquery';
import 'owl.carousel/dist/owl.carousel.min';

import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';

const iniOwlCarousel = (element) => {
    const options = {
        loop: true,
        autoplay: false,
        autoplayTimeout: 3500,
        autoplayHoverPause: true,
        margin: 10,
        nav: false,
        stagePadding: 3,
        slideBy: 8,
        navText: [
            '<i class="fa fa-angle-left" aria-hidden="true"></i>',
            '<i class="fa fa-angle-right" aria-hidden="true"></i>',
        ],
        responsive: {
            0: {
                items: 2,
            },
            600: {
                items: 6,
            },
            1000: {
                items: 8,
            },
        },
    };
    element.owlCarousel(options);
};

$(document).ready(() => {
    iniOwlCarousel($('#partners-slider'));
});
